/* AM Features v2 - slider movil con BUCLE infinito (como serenafirenze.com) y puntos.
   Bucle: se pone una copia de la ULTIMA ventaja delante y una de la PRIMERA detras.
   Al pararse el deslizamiento sobre una copia, se salta sin animacion a la real
   equivalente (se ve exactamente lo mismo, asi que el salto no se nota).
   Eventos por DELEGACION en document (click, y scroll en fase de captura porque no
   burbujea): en este tema los listeners puestos en nodos concretos se pierden. */
(function () {
  if (window.__amFeat2) return;
  window.__amFeat2 = 1;

  var SEC = '[data-am-feat]';
  function isMobile() { return window.matchMedia('(max-width: 749px)').matches; }
  function reals(track) { return track.querySelectorAll('.am-feat__item:not([data-clone])'); }

  function jump(track, left) {
    var snap = track.style.scrollSnapType;
    track.style.scrollSnapType = 'none';
    track.style.scrollBehavior = 'auto';
    track.scrollLeft = left;
    void track.offsetWidth; /* reflow antes de devolver el snap */
    track.style.scrollSnapType = snap;
    track.style.scrollBehavior = '';
  }

  /* indice real (0..n-1) segun la posicion; la posicion 0 es la copia de la ultima */
  function realIndex(track) {
    var n = reals(track).length, w = track.clientWidth || 1;
    var i = Math.round(track.scrollLeft / w) - 1;
    return ((i % n) + n) % n;
  }

  function sync(track) {
    var sec = track.closest(SEC);
    if (!sec) return;
    var k = realIndex(track);
    var dots = sec.querySelectorAll('.am-feat__dot');
    for (var d = 0; d < dots.length; d++) {
      var on = d === k;
      dots[d].classList.toggle('is-active', on);
      if (on) dots[d].setAttribute('aria-current', 'true');
      else dots[d].removeAttribute('aria-current');
    }
  }

  /* si esta sobre una copia, saltar a la real */
  function settle(track) {
    var n = reals(track).length, w = track.clientWidth || 1;
    var i = Math.round(track.scrollLeft / w);
    if (i <= 0) jump(track, n * w);
    else if (i >= n + 1) jump(track, w);
    sync(track);
  }

  function place(track) {
    if (!isMobile() || !track.clientWidth) return;
    var i = Math.round(track.scrollLeft / track.clientWidth);
    if (i < 1) jump(track, track.clientWidth); /* arrancar en la primera REAL */
    sync(track);
  }

  function init(sec) {
    var track = sec.querySelector('.am-feat__track');
    if (!track) return;
    /* un clon de la seccion conserva las copias pero no la propiedad: limpiar y rehacer */
    if (sec.__amFeat2 && track.querySelector('[data-clone]')) { place(track); return; }
    var old = track.querySelectorAll('[data-clone]');
    for (var o = 0; o < old.length; o++) old[o].parentNode.removeChild(old[o]);
    var items = reals(track);
    if (items.length < 2) return;
    sec.__amFeat2 = 1;
    var first = items[0].cloneNode(true), last = items[items.length - 1].cloneNode(true);
    [first, last].forEach(function (c) {
      c.setAttribute('data-clone', '');
      c.setAttribute('aria-hidden', 'true');
      c.removeAttribute('data-shopify-editor-block');
    });
    track.insertBefore(last, track.firstChild);
    track.appendChild(first);
    place(track);
  }

  function scan() {
    var secs = document.querySelectorAll(SEC);
    for (var i = 0; i < secs.length; i++) init(secs[i]);
  }

  var timers = new WeakMap();
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('am-feat__track')) return;
    sync(t);
    clearTimeout(timers.get(t));
    timers.set(t, setTimeout(function () { settle(t); }, 130));
  }, true);

  document.addEventListener('click', function (e) {
    var dot = e.target && e.target.closest ? e.target.closest('.am-feat__dot') : null;
    if (!dot) return;
    var sec = dot.closest(SEC);
    var track = sec ? sec.querySelector('.am-feat__track') : null;
    if (!track) return;
    var k = parseInt(dot.getAttribute('data-i'), 10) || 0;
    var left = (k + 1) * track.clientWidth; /* +1 por la copia de delante */
    /* con la pestana oculta no hay animacion ni evento scroll: salto directo + sync */
    if (document.hidden) { jump(track, left); sync(track); }
    else track.scrollTo({ left: left, behavior: 'smooth' });
  });

  var deb = null;
  function scanLater() { clearTimeout(deb); deb = setTimeout(scan, 120); }
  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);
  window.addEventListener('load', scanLater);
  window.addEventListener('resize', function () {
    var ts = document.querySelectorAll(SEC + ' .am-feat__track');
    for (var i = 0; i < ts.length; i++) place(ts[i]);
  });
  document.addEventListener('shopify:section:load', scanLater);
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var m = 0; m < muts.length; m++) {
        var n = muts[m].target;
        if (n && n.closest && n.closest('.am-feat__track')) continue; /* nuestras copias */
        scanLater(); return;
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
